import { FunctionComponent, ReactNode, useCallback, useEffect, useRef } from "react";
import ClickableDiv from "./ClickableDiv";
import "./Modal.css";

interface IProps {
	content: ReactNode;
	footer: ReactNode;
	title: string;
	subTitle?: string;
    open: boolean;
	className?: string;
    onClose(): void;
}

const Modal: FunctionComponent<IProps> = (props) => {
	const { title, subTitle,content,footer,open, className, onClose } = props;
	const modal = useRef<HTMLDivElement>(null);
	
	const onWindowClick = useCallback((event: MouseEvent) => {
		if (!modal.current?.contains(event.target as Node)) {
			onClose();
			event.stopPropagation();
			event.preventDefault();
		}
	}, [onClose]);

	useEffect(() => {
		if (!open) { return; }
		window.addEventListener("mousedown", onWindowClick);
		return () => window.removeEventListener("mousedown", onWindowClick);
	}, [onWindowClick, open]);

	if (!open) {
		return null;
	}

	return <div className={"modalForm modal focused animeImageForm " + (className ?? "")}>
		<div id="innerForm" className="modal-content animate" ref={modal}>
			<div className="container formTop">
				<h2 className="modalTitle">{title}</h2>
				{subTitle && <h3 className="modalSubTitle">{subTitle}</h3>}

				<ClickableDiv className="closeModal" onClick={onClose} title="Close">
					<i className="fa fa-times icon"></i>
				</ClickableDiv>
			</div>
			
			<div className="container">
				{content}
			</div>

			<div className="container" style={{ backgroundColor: "var(--main-bg-color-dark)", borderRadius: "8px" }}>
				{footer}
			</div>
		</div>
	</div>;
}

export default Modal;